import React from "react";
import { Zap, ArrowUp, Mail, Phone, MapPin, ChevronRight } from "lucide-react";
import { contact, footerProducts, SHOP_URL } from "../mock";

const Footer = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="bg-[#0a0a0c] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-[#f15a24]">
                <Zap size={20} className="text-white" fill="white" />
              </span>
              <span className="font-display font-bold text-white text-xl">
                Posi<span className="text-[#f15a24]">-Products</span>
              </span>
            </div>
            <p className="text-neutral-500 text-sm mt-4 leading-relaxed">
              Reusable, universal electrical connectors with superior
              performance. Division of Swenco Inc.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm tracking-wide uppercase">
              Get in touch
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li className="flex items-center gap-3 text-neutral-400">
                <Phone size={16} className="text-[#f15a24]" /> {contact.phoneAlt}
              </li>
              <li className="flex items-center gap-3 text-neutral-400">
                <Mail size={16} className="text-[#f15a24]" /> connect@plusgrow.com
              </li>
              <li className="flex items-start gap-3 text-neutral-400">
                <MapPin size={16} className="text-[#f15a24] mt-0.5 shrink-0" />
                {contact.address}
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-white font-semibold text-sm tracking-wide uppercase">
              Products
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              {footerProducts.map((p) => (
                <li key={p.label}>
                  <a
                    href={p.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-2 text-neutral-400 hover:text-[#f15a24] transition-colors"
                  >
                    <ChevronRight size={15} className="text-[#f15a24]" />
                    {p.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Imported by */}
          <div>
            <h4 className="text-white font-semibold text-sm tracking-wide uppercase">
              Imported & Marketed by
            </h4>
            <p className="text-neutral-400 text-sm mt-5 leading-relaxed">
              {contact.importedBy}
            </p>
            <a
              href={SHOP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 text-[#f15a24] font-semibold text-sm hover:gap-3 transition-all"
            >
              Buy on Motousher <ChevronRight size={16} />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-neutral-500 text-sm text-center sm:text-left">
            © {new Date().getFullYear()} Posi-Products · Plusgrow Merchantry Pvt Ltd, Nagpur 440016
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-neutral-500 text-sm hover:text-white transition-colors">
              Terms & Conditions
            </a>
            <a href="#" className="text-neutral-500 text-sm hover:text-white transition-colors">
              Privacy Policy
            </a>
            <button
              onClick={scrollTop}
              aria-label="Scroll to top"
              className="flex items-center justify-center w-10 h-10 rounded-full bg-white/5 text-white hover:bg-[#f15a24] transition-colors"
            >
              <ArrowUp size={18} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
